var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 270,
    height: 510,
    viewBox: "0 0 270 510",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "c5oze0ybma",
    width: "114.1%",
    height: "107.2%",
    x: "-7.1%",
    y: "-3.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.103911713 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "9xa4cwx7db",
    d: "M221.557 488H26.442C11.84 488 0 476.195 0 461.634V26.366C0 11.805 11.839 0 26.442 0h195.115C236.161 0 248 11.805 248 26.366v435.268C248 476.195 236.161 488 221.557 488"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1065 -301) translate(1076 310)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c5oze0ybma)",
    xlinkHref: "#9xa4cwx7db"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#8C8C8C",
    xlinkHref: "#9xa4cwx7db"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M216.456 483H31.544C17.437 483 6 471.591 6 457.517V31.483C6 17.409 17.437 6 31.544 6h184.912C230.563 6 242 17.41 242 31.483v426.034C242 471.591 230.563 483 216.456 483",
    transform: "translate(-1065 -301) translate(1076 310)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    fill: "#030303",
    fontFamily: "Helvetica",
    fontSize: 6.804,
    transform: "translate(-1065 -301) translate(1076 310) translate(17 12) translate(171.609 .713) translate(4.536)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1.309,
    y: 6
  }, "100%")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1065 -301) translate(1076 310) translate(17 12) translate(171.609 .713) translate(4.536) translate(20.412 2.268)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.567,
    d: "M11.055.283H1.42C1.105.283.82.41.616.615.41.818.283 1.1.283 1.411v3.132c0 .31.128.591.332.796.204.204.486.331.797.331h9.65c.311 0 .593-.126.798-.33.204-.205.33-.486.33-.797V1.41c0-.31-.127-.592-.333-.796-.205-.204-.489-.332-.802-.332z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.5,
    d: "M13.042 1.985c.488.126.85.57.85 1.098 0 .528-.362.972-.85 1.098z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.206,
    height: 3.686,
    x: 1.134,
    y: 1.134,
    fill: "#000",
    rx: 0.567
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1.984 1.134l2.269 2.268-1.418 1.7L4.253 6.52 1.984 8.79V5.67L.567 7.088l-.283-.284 1.7-1.701V4.82L0 3.118l.283-.283 1.702 1.418V1.134zm.568 4.536v1.701l.83-.85-.83-.851zm0-3.119v1.702l.869-.85-.87-.852z",
    transform: "translate(-1065 -301) translate(1076 310) translate(17 12) translate(171.609 .713)"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#030303",
    fontFamily: "Helvetica",
    fontSize: 6.804,
    transform: "translate(-1065 -301) translate(1076 310) translate(17 12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 98.839,
    y: 8.449
  }, "09:41")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#030303",
    d: "M14.168 3.668c.49 0 .93.213 1.223.55l-1.203 1.168L12.962 4.2c.293-.326.725-.531 1.206-.531zm0-1.692c.972 0 1.847.4 2.458 1.041l-.617.6c-.453-.488-1.11-.795-1.841-.795-.722 0-1.372.3-1.825.778L11.725 3c.611-.631 1.48-1.025 2.443-1.025zm0-1.692c1.453 0 2.764.589 3.692 1.534l-.616.6c-.77-.793-1.864-1.288-3.076-1.288-1.205 0-2.292.488-3.06 1.272l-.619-.598c.928-.937 2.233-1.52 3.679-1.52z",
    transform: "translate(-1065 -301) translate(1076 310) translate(17 12) translate(3.969 3.003)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.935 0c.158 0 .287.133.287.29v4.807c0 .16-.131.29-.287.29H7.09c-.159 0-.287-.134-.287-.29V.29c0-.16.13-.29.287-.29h.844zM5.667 1.417c.158 0 .287.133.287.286V5.1c0 .158-.131.285-.287.285h-.844c-.159 0-.287-.132-.287-.285V1.703c0-.158.13-.286.287-.286h.844zM3.399 2.551c.158 0 .287.122.287.283v2.27c0 .156-.131.282-.287.282h-.844c-.159 0-.287-.121-.287-.282v-2.27c0-.156.13-.283.287-.283h.844zM1.13 3.686c.158 0 .286.133.286.28v1.14c0 .155-.13.28-.286.28H.287c-.159 0-.287-.133-.287-.28v-1.14c0-.155.13-.28.287-.28h.844z",
    transform: "translate(-1065 -301) translate(1076 310) translate(17 12) translate(3.969 3.003)"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ad157471.svg";
export { ForwardRef as ReactComponent };